import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, MenuItem, MenuList, Popover, Typography, Stack, Avatar, Chip } from '@mui/material';
import { useAuth } from 'src/hooks/use-auth';
import { useNavigate } from 'react-router-dom';

export const AccountPopover = (props) => {
  const { anchorEl, onClose, open } = props;
  const navigate = useNavigate();
  const auth = useAuth();

  function safeParse(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  // prefer context, fallback to localStorage
  const lsUser = safeParse(localStorage.getItem('userData'));
  const user = (auth && auth.user) ? auth.user : lsUser || {};

  const name = user && (user.name || user.fullName || user.displayName) || '';
  const email = user && user.email ? user.email : '';
  const rolesArr = Array.isArray(user && user.roles)
    ? user.roles
    : (user && user.role ? String(user.role).split(',').map(function(s){ return s.trim(); }) : []);
  const section = user && user.section ? String(user.section) : '';

  const primaryRole = rolesArr && rolesArr.length ? rolesArr[0] : '';
  const initials = name ? name.split(' ').map(function(p){ return p[0]; }).join('').substring(0, 2).toUpperCase() : '';
  const roleAndSection = (primaryRole || '') + (section ? ' • ' + section : '');

  function handleSignOut() {
    if (auth && auth.signOut) { auth.signOut(); }
    localStorage.removeItem('userData');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userSection');
    navigate('/');
  }

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 260 } }}
    >
      <Box style={{paddingTop: `40px`}} sx={{ py: 1.5, px: 2 }}>
        <Typography variant='overline'>Account</Typography>
        <Stack direction='row' spacing={1.5} alignItems='center' sx={{ mt: 1 }}>
          <Avatar src={user && user.picture ? user.picture : undefined}>{initials}</Avatar>
          <Box>
            <Typography variant='subtitle2'>{name || 'User'}</Typography>
            {email ? <Typography color='text.secondary' variant='caption'>{email}</Typography> : null}
            {primaryRole || section ? (
              <Stack direction='row' spacing={0.5} sx={{ mt: 0.5 }} flexWrap='wrap'>
                {primaryRole ? <Chip size='small' label={primaryRole} /> : null}
                {section ? <Chip style={{marginTop: `5px`}} size='small' variant='outlined' label={section} /> : null}
              </Stack>
            ) : null}
            {/* If you prefer plain text over Chips, replace the Stack above with:
            {roleAndSection ? <Typography color='text.secondary' variant='body2'>{roleAndSection}</Typography> : null}
            */}
          </Box>
        </Stack>
      </Box>

      <Divider />

      <MenuList
        disablePadding
        dense
        sx={{ p: '8px', '& > *': { borderRadius: 1 } }}
      >
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </MenuList>
    </Popover>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};
